<template>
  <v-container class="pa-0 home bbb" :class="{aaa:flagZt}">
    <v-carousel :style="{
          height:imageH
        }" cycle hide-delimiters>
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <nav :style="{
          height:navH
        }">
      <router-link 
        class="nav-item white--text"
        v-for="(nav, index) in navLink"
        :key="index"
        :style="{
          backgroundColor: nav.color,
          height:nav.navItemH
        }"
        :to="nav.link ? nav.link : null"
      >
        <v-icon color="white">{{ nav.icon }}</v-icon>
        <div class="title">{{ nav.title }}</div>
      </router-link>
      <div
        class="nav-item white--text"
        style="background-color: #79c5c0;"
        :style="{
          gridColumn: column,
          height:loginH
        }"
        @click="dialog = true"
      >
        <v-icon color="white">mdi-logout</v-icon>
        <div class="title">重新登录</div>
      </div>
    </nav>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">提示</span>
        </v-card-title>
        <v-card-text>
          <span>确认重新登录吗？</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="logout"> 确认 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <core-footer /> -->
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import Cookie from "js-cookie";

export default {
  name: "Home",
  components: {},
  data: () => ({
    dialog: false,
    loginH:0,
    imageH:0,
    navItemH:0,
    navH:0,
    items: [
      {
        src: require("../assets/img/1.jpg"),
      },
      {
        src: require("../assets/img/2.jpg"),
      },
      {
        src: require("../assets/img/3.jpg"),
      },
      {
        src: require("../assets/img/4.jpg"),
      },
    ],
    flagZt:false
  }),
  mounted(){
        this.flagZt = this.IsPC()
        console.log(this.flagZt+'');
        if(!this.flagZt){
          let imageHnumber = 200;
          let navParts = 5

          if(this.user.role?.includes('SCN') || this.user.role?.includes('Dealer')){
              imageHnumber = 200;
              navParts = 3
          }
          this.imageH =  imageHnumber + 'px';
          let navHnumber = (this.$el.clientHeight-imageHnumber);
          
          this.navH = navHnumber + 'px';
          this.loginH = navHnumber/navParts + 'px';
          this.navItemH = ((navHnumber/navParts)*2) + 'px';
          let scope = this;
          window.addEventListener('resize', () => {
            imageHnumber = 200;
            navParts = 5
            if(scope.user.role?.includes('SCN') || this.user.role?.includes('Dealer')){
              imageHnumber = 200;
              navParts = 3
            }
            // We execute the same script as before
            scope.imageH =  imageHnumber + 'px';
            let navHnumber = (scope.$el.clientHeight-imageHnumber);

            scope.navH = navHnumber + 'px';
            scope.loginH = navHnumber/navParts + 'px';//(window.innerHeight -200-48)/6 + 'px';
            scope.navItemH = ((navHnumber/navParts)*2) + 'px';//(window.innerHeight -200-48)*2/6 + 'px';
          });
        }else{
          let imageHnumber = 400;
          let navParts = 5

          if(this.user.role?.includes('SCN') || this.user.role?.includes('Dealer')){
              imageHnumber = 400;
              navParts = 3
          }

          this.imageH =  imageHnumber + 'px';
          let navHnumber = (this.$el.clientHeight-imageHnumber);
          
          this.navH = navHnumber + 'px';
          this.loginH = navHnumber/navParts + 'px';
          this.navItemH = ((navHnumber/navParts)*2) + 'px';
          let scope = this;
          window.addEventListener('resize', () => {
            imageHnumber = 400;
            navParts = 5
            if(scope.user.role?.includes('SCN') || this.user.role?.includes('Dealer')){
              imageHnumber = 400;
              navParts = 3
            }
            // We execute the same script as before
            scope.imageH =  imageHnumber + 'px';
            let navHnumber = (scope.$el.clientHeight-imageHnumber);

            scope.navH = navHnumber + 'px';
            scope.loginH = navHnumber/navParts + 'px';//(window.innerHeight -200-48)/6 + 'px';
            scope.navItemH = ((navHnumber/navParts)*2) + 'px';//(window.innerHeight -200-48)*2/6 + 'px';
          });
        }
        
  },
  computed: {
    ...mapState(["user"]),
    navLink() {
      if (this.user.role?.includes('RRS')) {
        return [
          {
            title: "目标管理",
            color: "#9E2896",
            icon: "mdi-bullseye-arrow",
            link: "/target",
            navItemH:this.navItemH
          },
          {
            title: "日常拜访",
            color: "#551151",
            icon: "mdi-calendar-month",
            link: "/visiting",
            navItemH:this.navItemH
          },
          {
            title: "客户管理",
            color: "#56B0FF",
            icon: "mdi-cart-variant",
            link: "/distributor",
            navItemH:this.navItemH
          },
          {
            title: "门店管理",
            color: "#006EAD",
            icon: "mdi-home-city",
            link: "/store",
            navItemH:this.navItemH
          },
          // {
          //   title: "人员管理",
          //   color: "#00884A",
          //   icon: "mdi-account",
          //   link: "/user",
          //   navItemH:this.loginH
          // },
        ];
      } else if(this.user.role?.includes('SCN')){
        return [
          {
            title: "客户管理",
            color: "#56B0FF",
            icon: "mdi-cart-variant",
            link: "/distributor",
            navItemH:this.navItemH
          },
          {
            title: "门店管理",
            color: "#006EAD",
            icon: "mdi-home-city",
            link: "/store",
            navItemH:this.navItemH
          },
        ];
      } else if(this.user.role?.includes('Dealer')){
        return [
          {
            title: "日常拜访",
            color: "#551151",
            icon: "mdi-calendar-month",
            link: "/visiting",
            navItemH:this.navItemH
          },
          {
            title: "客户管理",
            color: "#56B0FF",
            icon: "mdi-cart-variant",
            link: "/distributor",
            navItemH:this.navItemH
          }
        ];
      } else if(this.user.role?.includes('External Sales')){
        return [
          {
            title: "日常拜访",
            color: "#551151",
            icon: "mdi-calendar-month",
            link: "/visiting",
            navItemH:this.navItemH
          },
          {
            title: "客户管理",
            color: "#56B0FF",
            icon: "mdi-cart-variant",
            link: "/distributor",
            navItemH:this.navItemH
          },
          {
            title: "门店管理",
            color: "#006EAD",
            icon: "mdi-home-city",
            link: "/store",
            navItemH:this.navItemH
          }
        ];
      } else {
        return [
          {
            title: "目标管理",
            color: "#9E2896",
            icon: "mdi-bullseye-arrow",
            link: "/target",
            navItemH:this.navItemH
          },
          {
            title: "日常拜访",
            color: "#551151",
            icon: "mdi-calendar-month",
            link: "/visiting",
            navItemH:this.navItemH
          },
          {
            title: "客户管理",
            color: "#56B0FF",
            icon: "mdi-cart-variant",
            link: "/distributor",
            navItemH:this.navItemH
          },
          {
            title: "门店管理",
            color: "#006EAD",
            icon: "mdi-home-city",
            link: "/store",
            navItemH:this.navItemH
          },
        ];
      }
    },
    column() {
      return this.user.role?.includes('RRS') ? "1/3" : "1/3";
    },
  },
  methods: {
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"];
      var flagPc = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flagPc = false;
          break;
        }
      }
      return flagPc;
    },
    logout() {
      Cookie.remove("adfs-token");
      //window.location.reload();
      // window.location.href = process.env.VUE_APP_API_BASE_URL + "rec/index.html#/login";
      window.location.href = process.env.VUE_APP_HOME_REC + "login";
    },
  },
};
</script>

<style lang="sass">
.home
  height: calc(100% - 0px)
  .v-image__image
    background-position: 0px 0px !important
    background-size:100% 100%
    max-width: 100% !important
    max-height: 200px !important
  nav
    width: 100%
    display: grid
    grid-template-rows: repeat(3, 1fr)
    grid-template-columns: repeat(2, 1fr)
    a.nav-item
      display: grid
      justify-content: flex-start
      align-content: center
      position: relative
      padding: 10px
      text-decoration: none
      .title
        position: absolute
        bottom: 5%
        right: 5%
        font-weight: 600
        top: 5%
        display: grid
        place-content: center
      .v-icon
        font-size: 48px
    div.nav-item
      display: grid
      justify-content: flex-start
      align-content: center
      position: relative
      padding: 10px
      text-decoration: none
      .title
        position: absolute
        bottom: 5%
        right: 5%
        font-weight: 600
        top: 5%
        display: grid
        place-content: center
      .v-icon
        font-size: 48px
</style>
<style>
  .aaa .v-image__image{
    max-height: 400px !important
  }
</style>
